import { define } from './theme.js';
class ProductStickyBar extends HTMLElement {
  connectedCallback() {
    const target = document.getElementById(this.getAttribute('target'));
    if (!target || !('IntersectionObserver' in window)) return;
    this.observer = new IntersectionObserver(([entry]) => {
      const show = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
      this.hidden = !show;
      this.toggleAttribute('open', show);
    });
    this.observer.observe(target);
  }
  disconnectedCallback() { this.observer?.disconnect(); }
}
define('product-sticky-bar', ProductStickyBar);
